import PortalRequestsListView from "../../components/portal/PortalRequestsListView";

const PortalRequests = () => {
    //RAQ & KYC lists

    return (
        <>
            <section className="home__query">
                <div className="home__query__content wrap portalbg">
                    <PortalRequestsListView stageOptions={["Request a quote", "Know Your Customer"]} />
                </div>
            </section>
        </>
    );
};

export default PortalRequests;
